// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2Im5g","approved":"Status_approved__1tWBF","rejected":"Status_rejected__8kznE","expired":"Status_expired__2sjlf","label":"Status_label__2vC53"};